<template>
  <div class="home-body">
    <van-tabs
      sticky
      v-model:active="activeName"
      color="#0F5293"
      background="#F4F9FD"
    >
      <van-tab title="今日值班" name="1">
        <OnDutyToday :type="activeName" />
      </van-tab>
      <van-tab title="值班预告" name="3">
        <OnDutyToday :type="activeName" />
      </van-tab>
      <van-tab title="值班回顾" name="2">
        <OnDutyToday :type="activeName" />
      </van-tab>
    </van-tabs>
  </div>
</template>
<script>
import { ref } from 'vue'
import OnDutyToday from './widget/tab.vue'
import { Tab, Tabs } from 'vant'
export default {
  name: 'App',
  components: {
    OnDutyToday,
    [Tab.name]: Tab,
    [Tabs.name]: Tabs
  },
  setup () {
    const activeName = ref('1')
    return {
      activeName
    }
  }
}
</script>
<style lang="less" scoped>
.is-active {
  .tab-name {
    height: 30px;
    font-family: PingFangSC-Semibold;
    font-weight: 600;
    font-size: 22px;
    color: #0f5293;
    letter-spacing: 0;
  }
}
.tab-name {
  font-family: PingFangSC-Regular;
  font-weight: 400;
  font-size: 22px;
  color: #0f5293;
  letter-spacing: 0;
}
.demo-tabs {
  box-sizing: border-box;
}
.home-body {
  margin: 0px;
  background-color: #fff;
}
</style>
